import React from "react";
import * as Scrivito from "scrivito";
import { Form } from "formik";

import { Question } from "./Question/Question";

export const WizardForm = Scrivito.connect(({ questions }) => (
  <Form className="mb-4">
    {questions.map((question) => (
      <Question data={question} key={question.identifier} />
    ))}
  </Form>
));
